/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import PropTypes from 'prop-types';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import { molecularModalReducerKey } from './MolecularModalConstants';
import { updateStateParams, resetState, initializeMolecularData } from './MolecularModalActions';
import Header from './Components/Header';
import Content from './Components/Content';

import './MolecularModal.scss';

function MolecularModal({ updateStringTypeDataValue, ...restProps }) {
  const { formulaText, molecularData } = useSelector((state) => state.get(molecularModalReducerKey));
  const dispatch = useDispatch();
  const inputRef = useRef();
  const [selectionStart, setSelectionStart] = useState(null);
  const [selectionEnd, setSelectionEnd] = useState(null);
  const isModalBodyAvailable =
    molecularData &&
    molecularData.elementsItems &&
    molecularData.elementsItems.length > 0 &&
    molecularData.specialGroupItems &&
    molecularData.specialGroupItems.length > 0;
  useEffect(() => {
    dispatch(initializeMolecularData());
    return () => {
      dispatch(resetState());
    };
  }, []);
  const getCursorPosition = (start, end) => {
    setSelectionStart(start);
    setSelectionEnd(end);
  };

  const resolveInputElement = () => {
    const currentRef = inputRef?.current;
    return currentRef?.inputRef?.current || currentRef || null;
  };

  const setCursorPosition = (position) => {
    const inputQuery = resolveInputElement();
    if (!inputQuery) {
      return;
    }

    const nextPosition = position ?? inputQuery.scrollWidth;

    inputQuery.focus();
    setTimeout(() => {
      inputQuery.setSelectionRange(nextPosition, nextPosition);
      setTimeout(() => {
        if (inputQuery) {
          inputQuery.scrollLeft = nextPosition;
        }
      }, 100);
    }, 100);
  };

  const addValueToQuery = (cell) => {
    const molecular = cell.builderValue || cell.name;
    let tempText = formulaText;
    let scrollInputValue = null;
    if (selectionStart && selectionEnd) {
      if (selectionStart === selectionEnd) {
        tempText = tempText.substring(0, selectionStart) + molecular + tempText.substring(selectionStart, tempText.length);
        // Update cursor position
        scrollInputValue = selectionStart + molecular.length;
      } else {
        tempText = tempText.substring(0, selectionStart) + molecular + tempText.substring(selectionEnd, tempText.length);
        // Update cursor position
        scrollInputValue = selectionEnd;
      }
    } else {
      tempText += molecular;
    }
    // Add to the formula input
    dispatch(updateStateParams({ formulaText: tempText }));
    // Update cursor position
    setCursorPosition(scrollInputValue);
    // Reset selections values
    getCursorPosition(null, null);
  };
  return (
    <GeneralDialogLayout {...restProps}>
      <div className="rx-modal-content-main">
        <Header getCursorPosition={getCursorPosition} inputRef={inputRef} updateStringTypeDataValue={updateStringTypeDataValue} />
        {isModalBodyAvailable ? <Content addValueToQuery={addValueToQuery} /> : <SimpleSpinner />}
      </div>
    </GeneralDialogLayout>
  );
}

MolecularModal.defaultProps = {
  updateStringTypeDataValue: () => {},
};
MolecularModal.propTypes = {
  updateStringTypeDataValue: PropTypes.func,
};

export default MolecularModal;
